<template>
  <div class="sharing-with-contact">
    <div v-show='isAddingContact'>
      <form ref='form' @submit.prevent="createContact($event)">
        <div class="modal-body">
          <h5> {{$t('contacts.edit_modal.add_contact')}}</h5>
          <div class="form-group">
            <label class="col-form-label">
              {{$t('contacts.edit_modal.name')}}
            </label>

            <input type="text" name="contact[name]" class="form-control" :value='contact.name' required/>
          </div>

          <div class="form-group">
            <label class="col-form-label">
              {{$t('contacts.edit_modal.email')}}
            </label>

            <input type="text" name="contact[email]" class="form-control" :value='contact.email' required/>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.language')}}</label>
            <select name="contact[locale]" class="form-control">
              <option :selected="contact.locale === 'en'" value='en'>{{$t('contacts.edit_modal.english')}}</option>
              <option :selected="contact.locale === 'de'" value='de'>{{$t('contacts.edit_modal.german')}}</option>
            </select>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.company')}}</label>
            <input type="text" name="contact[company]" class="form-control" :value='contact.company'/>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.position')}}</label>
            <input type="text" name="contact[position]" class="form-control" :value='contact.position'/>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.company_address')}}</label>
            <input type="text" name="contact[address]" class="form-control" :value='contact.address'/>
          </div>

          <div class="form-group">
            <label class='col-form-label'>{{$t('contacts.edit_modal.notes')}}</label>
            <textarea class="form-control" name="contact[notes]" :value='contact.notes'></textarea>
          </div>
        </div>

        <div class="modal-footer">
          <input type="button" name="commit" :value="$t('contacts.edit_modal.close')" class="btn btn-outline-primary float-right" @click.prevent='isAddingContact = false' />
          <input type="submit" name="commit" :value="$t('contacts.edit_modal.save')" class="btn btn-primary float-right" />
        </div>
      </form>
    </div>

    <div v-show='!isAddingContact'>
      <a v-if="folder && folder.share_invites.length > 0" href="#" class="float-right shared-with" @click.prevent="$emit('edit-mode')">
        {{ $t('share_invite.shared_with') }} {{ folder.share_invites.length }} {{ $t('share_invite.contacts') }}
        <i class="fa fa-long-arrow-right"></i>
      </a>

      <div class="form-group">
        <label>{{ $t('share_invite.select_permission') }}</label>
        <multiselect class="multiselect-sharing" v-model="share_type" label="title" track-by="title" :options="options" :show-labels="false" :option-height="104" :searchable="false" :allow-empty="false">
          <template slot="singleLabel" slot-scope="props">
          <span class="option__desc">
            <span class="option__title">{{ $t('share_invite.those_selected_below') }}
              <strong>{{ props.option.title }}</strong>
            </span>
          </span>
          </template>
          <template slot="option" slot-scope="props">
            <div class="option__desc">
            <span class="option__title">{{ $t('share_invite.those_selected_below') }}
              <strong>{{ props.option.title }}</strong>
            </span>
              <span class="option__small">{{ props.option.desc }}</span>
            </div>
          </template>
        </multiselect>
      </div>

      <div class="form-group">
        <label class="label-contacts">
          {{ $t('share_invite.select_contacts') }}
        </label>
        <infinite-multi-select :getter='getContacts' v-model='selectedContact' :template='contactTemplate' />
        <p class="sharing-note">{{ $t('share_invite.sharing_invite_note') }}</p>
      </div>

      <div class="form-group">
        <p><i class="fas fa-info-circle"></i>
          {{ $t('contacts.need_create') }} <a href="" @click.prevent="openContactForm">{{ $t('contacts.add_contact') }}</a></p>
      </div>

      <div class="form-group">
        <label>{{ $t('share_invite.add_mess') }}</label>
        <textarea class="message-textarea" placeholder="" v-model="message"></textarea>
        <a href="" :class="['btn btn-primary float-right', {disabled : selectedContact.length === 0}]" @click.prevent='submitForm()'>{{ $t('share_invite.share') }}</a>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
  import _infinite_multi_select from "../shared/_infinite_multi_select"
  import Multiselect from 'vue-multiselect'
  import _contact_form from '../shared/contacts/_contact_form'

  export default {
    components: {
      'multiselect': Multiselect,
      'contact-form': _contact_form,
      'infinite-multi-select': _infinite_multi_select,
    },
    props: ['folder'],
    data() {
      return {
        isAddingContact: false,
        contact: {},
        share_type: { title: this.$t('share_invite.can_read'), value: 'read'},
        message: '',
        selectedContact: [],
        options: [
          { title: this.$t('share_invite.can_read'), desc: this.$t('share_invite.view_info'), value: 'read'},
          { title: this.$t('share_invite.can_edit'), desc: this.$t('share_invite.write_info'), value: 'write'},
          { title: this.$t('share_invite.can_edit_folder_options'), desc: this.$t('share_invite.edit_info'), value: 'all'},
        ]
      }
    },
    methods: {
      getContacts(params) {
        return this.listStore.getContacts(params)
      },
      submitForm(){
        if(this.selectedContact.length === 0){
          this.$toastr.alert(this.$t('share_invite.select_contact'))
          return null
        }
        if(this.unverifiedUser){
          this.$toastr.alert(this.$t('verify.share_notice'))
          return null
        }
        let formData = {
          share_invite: {
            invite_type: this.$data.share_type.value,
            contact_ids: this.selectedContact.map(x => x.id),
            message: this.$data.message
          }
        }
        this.axios.post('/folders/' + this.$props.folder.id + '/share_invites', formData)
          .then(response => {
            this.selectedContact = []
            this.$emit('edit-mode')
            this.$toastr.success(this.$t('share_invite.folder_shared'))
            this.store.sendMetrics({name: 'share_folder_with_contact', params: this.$route.params, path: this.$route.fullPath})
          })
      },
      createContact(event) {
        const params = new FormData(event.target)

        this.store.createContact(params).then(({data}) => {
          this.store.sendMetrics({name: 'add_contact_from_sharing', params: this.$route.params, path: this.$route.fullPath})
          this.selectedContact.push(data)
          this.$toastr.success(this.$t('flash_messages.contact_created'))
          this.isAddingContact = false
        })
      },
      openContactForm() {
        this.isAddingContact = true
      },
      closeModal() {
        this.isAddingContact = false
        this.contact = {}
      },
    }
  }
</script>

<style lang="sass" scoped>
  .message-textarea
    height: 125px
    margin-bottom: 10px
  .sharing-note
    font-size: 12px
  .select-contact
    width: 100%
    border: 1px solid #e8e8e8
  p
    font-weight: 500
    font-size: 14px
    a:hover
      text-decoration: underline
    i
      color: #5072ED
      font-size: 19px
      vertical-align: middle
</style>
